import React from 'react'

function MoreUpdate() {
  return (
    <>
      <div className="more-update-section">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center gy-5">
            <div className="col-lg-6 text-lg-start text-center">
              <div className="more-update-content">
                <h2>Subscribe for early access</h2>
                <p>New workshops, releases and other news goes out to our subscribers before anyone else - sign up, and get a head start</p>
              </div>
            </div>
            <div className="col-lg-3 text-lg-end text-center">
            <a href="/subscribe" className="button-fill-round">Subscribe</a>
            </div>
          </div>
        </div>
      </div>   
    </>
  )
}

export default MoreUpdate